import { NgModule } from '@angular/core';


import { NumberToTimePipe } from './numberToTime.pipe';

@NgModule({
  imports: [
    NumberToTimePipe,
  ],
  exports: [
    NumberToTimePipe,
  ],
  declarations: [],
  providers: [],
})
export class SharedPipesModule {
}
